// extracted by mini-css-extract-plugin
module.exports = {"socials":"_2LmuqU","social":"_3nzZQo","facebook":"mtOO99","twitter":"_2KH6xC","pinterest":"_1nFrBj","instagram":"_273xZb"};